module.exports = "https://de18y2hs3hlxs.cloudfront.net/25e9b2d1-8359-4702-9df0-21a378808472/images/LogoHorizontal_White.svg?9c112b852f8360595639d7074f825d62";